class Auth {
    static user = null
    constructor (auth) {
        Auth.user = auth?.user;
        this.user = Auth.user;
    }
    
    static isLogged = (auth = Auth) => {
    	return process.env.MIX_APP_ENV=='production' ? !!auth.user : 
    		(sessionStorage.getItem('modo_guest') ? false : !!auth.user);
    }

    isLogged = () => {
    	return Auth.isLogged(this)/*process.env.MIX_APP_ENV=='production' ? !!this.user : 
    		(sessionStorage.getItem('modo_guest') ? false : !!this.user);*/
    }
}

export default Auth
